import { axios } from '@/utils/request'

const api = {
  goodsOptions: '/badminapi/youhuiquan/goodsOptions',
  giftDetail: '/badminapi/gift/giftDetail',
  giftList: '/badminapi/gift/giftList',
  cardPub: '/badminapi/gift/cardPub',
  giftAdd: '/badminapi/gift/add',
  giftDelete: '/badminapi/gift/giftDelete',
  giftCardLog: '/badminapi/gift/cardLogList',
  getGiftCardList: '/badminapi/gift/giftCardList',
  giftEdit:'/badminapi/gift/edit',
  giftCardAdd:'/badminapi/gift/giftCardAdd',
  getGiftCardDownload:'/badminapi/gift/getGiftCardDownloadUrl',
  cardAllPub:'/badminapi/gift/cardAllPub',
  cardAllCancel:'/badminapi/gift/cardAllCancel',
  editCard: '/badminapi/gift/editCard',
  cardCancel:'/badminapi/gift/cardCancel',
  editNote:'/badminapi/gift/editNote',
  getGiftOrderList:'/badminapi/gift/giftOrderList'
}

export default api

export function editCard(parameter) {
  return axios({
    url: api.editCard,
    method: 'post',
    data: parameter
  })
}
export function editNote(parameter) {
  return axios({
    url: api.editNote,
    method: 'post',
    data: parameter
  })
}
export function cardAllPub(parameter) {
  return axios({
    url: api.cardAllPub,
    method: 'post',
    params: parameter
  })
}
export function cardAllCancel(parameter) {
  return axios({
    url: api.cardAllCancel,
    method: 'post',
    params: parameter
  })
}

export function cardPub(parameter) {
  return axios({
    url: api.cardPub,
    method: 'post',
    params: parameter
  })
}
export function cardCancel(parameter) {
  return axios({
    url: api.cardCancel,
    method: 'post',
    params: parameter
  })
}
export function getGiftList(parameter) {
  return axios({
    url: api.giftList,
    method: 'get',
    params: parameter
  })
}
export function giftCardDownload(parameter) {
  return axios({
    url: api.getGiftCardDownload,
    method: 'get',
    params: parameter
  })
}
export function getGiftDetail(parameter) {
  return axios({
    url: api.giftDetail,
    method: 'get',
    params: parameter
  })
}

export function AddGiftCard(parameter) {
  return axios({
    url: api.giftCardAdd,
    method: 'post',
    params: parameter
  })
}
export function deleteGift(parameter) {
  return axios({
    url: api.giftDelete,
    method: 'get',
    params: parameter
  })
}

export function editGift(parameter) {
  return axios({
    url: api.giftEdit,
    method: 'post',
    data: parameter
  })
}


export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}
export function editCardStatus(parameter) {
  return axios({
    url: api.editCardStatus,
    method: 'post',
    data: parameter
  })
}
export function addGift(parameter) {
  return axios({
    url: api.giftAdd,
    method: 'post',
    data: parameter
  })
}

export function giftCardLogList(parameter) {
  return axios({
    url: api.giftCardLog,
    method: 'get',
    params: parameter
  })
}
export function setCouponAllStatus(parameter) {
  return axios({
    url: api.setCouponAllStatus,
    method: 'post',
    data: parameter
  })
}
export function getGiftCardList(parameter) {
  return axios({
    url: api.getGiftCardList,
    method: 'get',
    params: parameter
  })
}

export function getGiftOrderList(parameter) {
  return axios({
    url: api.getGiftOrderList,
    method: 'get',
    params: parameter
  })
}

